/* Core & libraries */
import { useTheme } from 'react-jss';

/* Helpers, constants, custom methods, internal libraries */
import DynamicImageLoader from '../../dynamicImageLoader';

/* Components */

/* Styles */
import styles from './styles.js';

const SpinnerBasic = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.spinner}>
      <DynamicImageLoader imageName={'loading-circle.svg'} />
    </div>
  );
};

export default SpinnerBasic;
